export const FirebaseConfig = {
  "projectId": "zippy-co",
  "appId": "1:464986575236:web:24a9fc8c88e9c389364dd1",
  "databaseURL": "https://zippy-co-default-rtdb.firebaseio.com",
  "storageBucket": "zippy-co.firebasestorage.app",
  "apiKey": "AIzaSyDCKVgjYSz_daLN8gLrdT1KoCZf-uBRnMg",
  "authDomain": "zippy-co.firebaseapp.com",
  "messagingSenderId": "464986575236",
  "measurementId": "G-0WWGYD5K2M",
  "projectNumber": "464986575236",
  "version": "2"
};
